import dayjs from 'dayjs';
import RelativeTime from 'dayjs/plugin/relativeTime';
import UpdateLocale from 'dayjs/plugin/updateLocale';

export const enLocaleConfig = {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%d secs',
        m: 'a minute',
        mm: '%d mins',
        h: 'an hour',
        hh: '%dh',
        d: 'a day',
        dd: '%dd',
        M: 'a month',
        MM: '%dmos',
        y: 'a year',
        yy: '%dy',
    },
};

dayjs.extend(RelativeTime);
dayjs.extend(UpdateLocale);
dayjs.updateLocale('en', enLocaleConfig);

export default dayjs;
